/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var Backbone = require('backbone');

var PlaceholderView = require('common/views/PlaceholderView');

var GetExamByLicense = require('../services/GetExamByLicense');

var NonDepLicenseExamsView = require('../views/NonDepLicenseExamsView');

module.exports = {
  channel: 'nd',

  event: 'build:license-exams-grid-view',

  builder: function(licenseId) {
    return new PlaceholderView({
      viewPromise: buildLicenseExamsView(licenseId)
    });
  }
};

function buildLicenseExamsView(licenseId) {
  var deferred = $.Deferred();

  GetExamByLicense(licenseId)
    .done(function(exams) {
      deferred.resolve(
        new NonDepLicenseExamsView({
          model: new Backbone.Model({
            licenseId: licenseId,
            exams: exams
          })
        })
      );
    })
    .fail(function(err) {
      deferred.reject(err);
    });

  return deferred.promise();
}
